import React, { useState, useContext } from 'react';
import axios from 'axios';
import { Card } from '../design-system';
import Alert from '../helpers/alert';
import { successRefetch } from '../helpers/data-loader';
import { required } from '../helpers/utils';
import ModalForm from './ModalForm';
import { Table, TableBody, TableCardHeader } from './Table';
import { ATTACHMENTS_COLUMNS, ERR_MSG } from '../globalConstants';
import { Session } from '../contexts/sessionContext';

interface AttachmentsProps {
  data: any[];
  modelId: any;
  modelType: string;
  clientId?: any;
  refetch: () => void;
  columns?: any[];
  maxHeight?: string;
  isEditing?: boolean;
  headerTextStyles?: any;
  disabled?: boolean;
  canEdit?: boolean;
}

const Attachments = ({
  data,
  modelId,
  modelType,
  clientId,
  refetch,
  columns,
  maxHeight,
  isEditing,
  headerTextStyles,
  disabled,
  canEdit,
}: AttachmentsProps) => {
  const [isOpenAttachmentsModal, setIsOpenAttachmentsModal] = useState(false);
  const [file, setFile] = useState<any>(null);
  const {
    state: {
      user: { agency_id },
    },
  } = useContext(Session);
  const ATTACHMENTS_FIELDS = [
    {
      name: 'file',
      label: 'File',
      validate: required,
      type: 'file',
      fileOnChange: (val) => setFile(val),
    },
    { name: 'description', label: 'Description' },
  ];

  const toggleAttachment = () => {
    setIsOpenAttachmentsModal(!isOpenAttachmentsModal);
  };

  const handleSubmit = async (values) => {
    const newFile = new FormData();
    newFile.append('file', file);
    newFile.append('description', values.description);
    newFile.append('agency_id', agency_id);
    newFile.append('model_type', modelType);
    newFile.append('model_id', modelId);
    if (clientId) {
      newFile.append('client_id', clientId);
    }
    try {
      await axios.post('/file', newFile);
      successRefetch(refetch);
      toggleAttachment();
    } catch (error) {
      Alert.error(ERR_MSG);
    }
  };

  const handleDeleteAttachment = async (id) => {
    try {
      await axios.delete(`/file/${id}`);
      successRefetch(refetch);
    } catch (error) {
      Alert.error(ERR_MSG);
    }
  };

  return (
    <Card id="attachments-table" mt={20}>
      <TableCardHeader
        name="Attachments"
        action="Add Attachment"
        onClick={toggleAttachment}
        {...({ headerTextStyles } as any)}
        disabled={disabled || (isEditing !== undefined && !isEditing)}
      />
      <TableBody {...({ maxHeight: maxHeight || '42rem' } as any)}>
        <Table
          columns={columns || ATTACHMENTS_COLUMNS}
          data={data.map((item) => ({
            ...item,
            handleDeleteAttachment,
            canEdit,
          }))}
        />
      </TableBody>
      <ModalForm
        isOpen={isOpenAttachmentsModal}
        title="Add Attachment"
        onSubmit={handleSubmit}
        onClose={toggleAttachment}
        fields={ATTACHMENTS_FIELDS}
        oneColumn
      />
    </Card>
  );
};

export default Attachments;
